import React from 'react';
import { FadeIn } from './FadeIn';
import { Droplets, Waves, Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-138">
      {/* Decorative leaf-like shapes */}
      <div className="absolute -right-20 top-20 w-64 h-64 bg-emerald/10 rounded-full blur-3xl" data-id="element-139" />
      <div className="absolute -left-20 bottom-20 w-64 h-64 bg-forest/10 rounded-full blur-3xl" data-id="element-140" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-141">
        <FadeIn data-id="element-142">
          <div className="text-center mb-16" data-id="element-143">
            <span className="text-emerald font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-144">
              El Secreto de la Recuperación
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-forest mb-6" data-id="element-145">
              El Método S.A.L.
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-146">
              Este protocolo no se trata de comer menos, sino de{' '}
              <strong className="text-forest" data-id="element-147">hidratar con inteligencia</strong>
              . Usamos una combinación exacta de minerales traza y agua
              estructurada para activar la "bomba sodio-potasio".
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-148">
          <FadeIn delay={0.2} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-emerald text-center" data-id="element-149">
            <div className="w-16 h-16 bg-emerald/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-150">
              <span className="text-3xl font-serif font-bold text-emerald" data-id="element-151">
                S
              </span>
            </div>
            <h3 className="text-xl font-bold text-forest mb-4" data-id="element-152">
              Sodio (Correcto)
            </h3>
            <p className="text-gray-600 text-sm" data-id="element-153">
              Minerales traza esenciales que tu cuerpo necesita para conducir la
              electricidad celular, no la sal de mesa refinada.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-emerald text-center" data-id="element-154">
            <div className="w-16 h-16 bg-emerald/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-155">
              <span className="text-3xl font-serif font-bold text-emerald" data-id="element-156">
                A
              </span>
            </div>
            <h3 className="text-xl font-bold text-forest mb-4" data-id="element-157">Agua</h3>
            <p className="text-gray-600 text-sm" data-id="element-158">
              Agua estructurada que realmente penetra la pared celular en lugar
              de simplemente pasar por tus riñones.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-emerald text-center" data-id="element-159">
            <div className="w-16 h-16 bg-emerald/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-160">
              <span className="text-3xl font-serif font-bold text-emerald" data-id="element-161">
                L
              </span>
            </div>
            <h3 className="text-xl font-bold text-forest mb-4" data-id="element-162">Limpieza</h3>
            <p className="text-gray-600 text-sm" data-id="element-163">
              Obligamos a la célula a expulsar el agua sucia y absorber los
              nutrientes que realmente necesita para sanar los tejidos.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}